module.exports = __webpack_public_path__ + "img/weiquan_ipone.17153c8a.png";